import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import About from './About';
import Service from './Service';
import Contact from './Contact';
import Gallery from './Gallery';
import Technologies from "./Technologies"
import reportWebVitals from './reportWebVitals';
import ScrollToTopButton from './ScrollToTopButton';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/service' element={<Service />} />
        <Route path='/techno' element={<Technologies />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/gallery' element={<Gallery />} />
      </Routes>
      <ScrollToTopButton />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();

